import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// BOOTSTRAP COMPONENTS
import { InputGroup } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite'

// STYLES
import styles from './addon.module.scss';

// MAIN COMPONENT
const Addon = ({
  prepend,
  as: Component,
  children,
  className,
  label,
  use,
  onClick,
  size,
  plaintext,
  ...props
}) => (!children && !label && !use && !Component) || plaintext ? null : Component ? (
    <Component
      label={label}
      size={size}
      onClick={onClick}
      {...props}
    />
  ) : (
    <InputGroup.Text
      className={clsx(
        styles.text,
        prepend ? styles.prepend : styles.append,
        size && styles[size],
        onClick && styles.pointer,
        className
      )}
      onClick={onClick}
    >
      {children ? children : label ? (
        <span className={styles.label}>{label}</span>
      ) : (
        <Sprite use={use} size={size} {...props} />
      )}
    </InputGroup.Text>
)

// EXPORT
export default Addon
